import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import api from "../services/api";
import BotaoVoltar from "../components/BotaoVoltar";

export default function Checkins() {
  const [checkins, setCheckins] = useState([]);

  useEffect(() => {
    api
      .get("/me/checkins/")
      .then((res) => setCheckins(res.data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <Navbar />

      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fw-bold">Meus Check-ins</h2>
          <BotaoVoltar to="/dashboard"/>
        </div>

        <div className="text-end">
          <Link className="btn btn-primary mb-3" to="/checkins/new">
              + Novo Check-in
          </Link>
        </div>

        {checkins.length === 0 && <p>Nenhum check-in registrado ainda.</p>}

        <div className="row">
          {checkins.map((ch) => (
            <div key={ch.id} className="col-md-6 mb-4">
              <div className="card shadow-sm h-100">

                {/* Imagem se existir */}
                {ch.evidencia ? (
                  <img
                    src={ch.evidencia}
                    alt="Evidência do check-in"
                    className="card-img-top"
                    style={{
                      width: "100%",
                      height: "280px",
                      objectFit: "cover",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light text-muted"
                    style={{
                      padding: "5px 0",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                    }}
                  >
                  </div>
                )}


                <div className="card-body">
                  <h5 className="fw-bold mb-2">
                    {ch.desafio_emoji} {ch.desafio_titulo}
                  </h5>

                  <p className="text-muted mb-2">
                    {new Date(ch.data_hora_checkin).toLocaleString("pt-BR")}
                  </p>

                  {ch.desafio_concluido ? (
                    <span className="badge bg-success">Concluído</span>
                  ) : (
                    <span className="badge bg-warning text-dark">Pendente</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
